function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMy = function SvgMy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flag-icons-my",
    viewBox: "0 0 640 480",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "rect2186",
    d: "M0 0h640v480H0z",
    style: {
      fill: "#c00",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2188-1",
    d: "M.5 39.9h639v38.4H.5z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.979059
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2188-1-9",
    d: "M.5 118.6h639V157H.5z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.979059
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2188-1-9-1",
    d: "M.5 197.4h639v38.4H.5z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.979059
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path837",
    fill: "#006",
    d: "M0 .5h320v280H0Z",
    style: {
      strokeWidth: 0.0571662
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path841",
    fill: "#fc0",
    d: "m207.5 73.8 6 40.7 23-34-12.4 39.2 35.5-20.8-28.1 30 41-3.2-38.3 14.8 38.3 14.8-41-3.2 28.1 30-35.5-20.8 12.3 39.3-23-34.1-6 40.7-5.9-40.7-23 34 12.4-39.2-35.5 20.8 28-30-41 3.2 38.4-14.8-38.3-14.8 41 3.2-28.1-30 35.5 20.8-12.4-39.3 23 34.1zm-33.3 1.7a71.1 71.1 0 1 0 0 130 80 80 0 1 1 0-130z",
    style: {
      strokeWidth: 0.0555556
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2188-1-9-1-4",
    d: "M.5 276.2h639v38.4H.5z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.979059
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2188-1-9-1-4-4",
    d: "M.5 354.4h639v38.4H.5z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.979059
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect2188-1-9-1-4-4-6",
    d: "M0 441.6h639V480H0z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.979059
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/my.9a1a93aa.svg";
export { ForwardRef as ReactComponent };